import RegistrationData from './registrationData'
export default RegistrationData
